/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import axios from "axios";

import { errorHandler, options } from "./index";
// import history from '../history/index';
// import types from '../actions/types';
import { API_URL } from "../config";
import IsUserUnauthorized from "../utils/unauthorized";
// import { actions } from '../reducers/app';
// import STATIC_ROUTES from '../route/STATIC_ROUTES';

export function downloadLog(user) {
  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/downloadLog", user, "post"));
      const responseOK = response && response.status === 200 && response.statusText === "OK";
      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}

export function getDownloadLogInfo() {
  const data = { title: "getData" };

  return async (dispatch) => {
    try {
      const response = await axios(options(API_URL + "/getDownloadLogInfo", data, "get")).catch(
        (error) => {
          if (error.response) {
            const status = error?.response?.status;
            IsUserUnauthorized(status);
          }
        }
      );

      const responseOK = response && response.status === 200 && response.statusText === "OK";

      if (responseOK) {
        return response.data;
      }
    } catch (error) {
      console.warn("Error:", error);
      dispatch(errorHandler(error));
    }
  };
}
